import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = (props) => ({
    root: css({
        width: '427px',
        height: '129px',
        backgroundColor: Color.neutral[0],
        position: 'relative',
        padding: '10px 15px',
        boxSizing: 'border-box',
    }),
    ribbon: css({
        width: '9px',
        height: '100%',
        position: 'absolute',
        right: 0,
        top: 0,
        backgroundColor: props.color,
    }),
    rightArrow: css({
        color: Color.primary[200],
        fontSize: '20px',
        marginLeft: '5px',
        marginRight: '5px',
    }),
    arrowHeadRight: css({
        color: Color.primary[300],
        fontSize: '24px',
    }),
    close: css({
        color: Color.danger[400],
        fontSize: '24px',
        paddingRight: '5px',
        display: props.isDeleteable ? 'block' : 'none',
    }),
    location: css({
        color: Color.primary[200],
        fontSize: '20px',
        marginRight: '3px',
    }),
    clock: css({
        color: Color.primary[300],
        fontSize: '20px',
        marginLeft: '5px',
    }),
    timeInformation: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: props.isCompared ? '315px' : '100%',
        height: '24px',
        backgroundColor: 'rgba(198, 229, 247, 0.23)',
        marginTop: '7px',
    }),
    flexStart: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    }),
    flexSpaceBetween: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    }),
});
